module.exports = __webpack_public_path__ + "static/media/fabianCamp.a22fa43c.jpeg";